export type Levels = 'client' | 'project' | 'service';

export interface ProjectFilter {
  projectId: string;
  actionNameFilter?: string[];
  recipeSourceFilter?: string;
}

export class ProcessesPopState {
  level: Levels;
  id?: string | string[];
  actionNameFilter?: string[];
  projectFilters?: ProjectFilter[];
}

export interface ProcessesPopOpenPayload {
  level: Levels;
  id?: string | string[];
  actionNameFilter?: string[];
  projectFilters?: ProjectFilter[];
}
